import { Box, Button, Grid, List, ListItem, MenuItem, Paper, Select } from '@material-ui/core';
import React from 'react';
import { IEpisodeVariant } from '../../services/types';
import useStyles from './styles';

interface IEpisodeVariantProps {
  variant: IEpisodeVariant;
  episodeAbTestList: any[];
  removeVariant: () => void;
  onChangeVariant: (k: string, v: any) => void;
  editable: boolean;
}
interface ITestEpisode {
  id: number;
  title: string;
}

const EpisodeVariant = (props: IEpisodeVariantProps): JSX.Element => {
  const { onChangeVariant, removeVariant, episodeAbTestList, variant, editable } = props;
  const classes = useStyles();

  const onChangeTest = (episodeId: number, testId: any) => {
    const newVariantData = Object.assign(variant.data, { [episodeId]: testId });
    onChangeVariant('data', newVariantData);
  };

  const onSelectEpisode = (episodeId: any) => {
    const newVariantData = Object.assign(variant.data, { [episodeId]: null });
    onChangeVariant('data', newVariantData);
  };

  const removeSelectedEpisode = (episodeId: number | string) => {
    const newVariantData = Object.assign({}, variant.data);
    delete newVariantData[episodeId];
    onChangeVariant('data', newVariantData);
  };

  const selectedEpisodes = episodeAbTestList.filter(test => {
    return variant.data[test.id] !== undefined;
  });

  const remainEpisodeAbTestList = episodeAbTestList.filter(test => {
    return variant.data[test.id] === undefined;
  });

  return (
    <Paper className={classes.variantPaper}>
      {variant.id && (
        <Grid item xs={12}>
          ID: {variant.id}
        </Grid>
      )}
      {editable && (
        <Box display="flex" flexDirection="row" alignItems="center" paddingBottom={2}>
          <Select
            fullWidth
            value={0}
            onChange={e => {
              if (e.target.value !== 0) {
                onSelectEpisode(e.target.value);
              }
            }}
            style={{ marginRight: 10 }}
          >
            <MenuItem key={`episodelistitem-00`} value={0}>
              Select Episode
            </MenuItem>
            {remainEpisodeAbTestList.map((episode, idx: number) => (
              <MenuItem key={`episodelistitem-${episode.id}`} value={episode.id}>{`${episode.no}. ${episode.title ||
                `Episode #${episode.no}`}`}</MenuItem>
            ))}
          </Select>
          <Button color="secondary" size="small" variant="outlined" onClick={removeVariant} disabled={!editable}>
            <i className="material-icons">delete</i>
          </Button>
        </Box>
      )}
      {selectedEpisodes.length > 0 && (
        <List component="div">
          {selectedEpisodes.map(testEpisode => (
            <ListItem key={`ep-li-${testEpisode.id}`} component="div" divider>
              <Grid container key={`variant-${testEpisode.id}`} spacing={2} alignItems="center">
                <Grid item xs={6}>
                  {testEpisode.no}. {testEpisode.title || `Episode #${testEpisode.no}`}
                </Grid>
                <Grid item xs={5}>
                  <Select
                    fullWidth
                    value={variant.data[testEpisode.id] || 0}
                    onChange={(e, c) => {
                      onChangeTest(testEpisode.id, e.target.value);
                    }}
                    disabled={!editable}
                  >
                    <MenuItem key={`abtestitem-00`} value={0}>
                      Select Test
                    </MenuItem>
                    {testEpisode.abTests.map((test: ITestEpisode) => (
                      <MenuItem key={`abtestitem-${test.id}`} value={test.id}>
                        {test.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <Button color="default" size="small" variant="contained" onClick={() => removeSelectedEpisode(testEpisode.id)}>
                    remove
                  </Button>
                </Grid>
              </Grid>
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
};

export default EpisodeVariant;
